import Skeleton from "react-loading-skeleton";
import styles from './WalletLoadingSkeleton.module.scss'; 

export const WalletLoadingSkeleton = () => (
	<div className={styles.loadingContainer}>
		<Skeleton width={250} height={250} />
		<Skeleton width="60%" height={28} />
		<Skeleton count={2} height={14} style={{ marginBottom: 4 }} />
		<div style={{ width: "100%", marginTop: 18 }}>
			<Skeleton height={52} style={{ marginBottom: 12 }} />
			<Skeleton height={52} />
		</div>
		<Skeleton width="100%" height={52} borderRadius={100} style={{ marginTop: 24 }} />
	</div>
);
